var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showText)?_c('div',{staticClass:"marquee"},[_c('div',{staticClass:"bbox",attrs:{"id":"box_el"}},[_c('div',{staticClass:"content",class:{ move: _vm.move },attrs:{"id":"con_el"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }